import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import { toast } from 'sonner';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginWithToken } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL hash
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error('No session_id found in URL');
          toast.error('Authentication failed - no session ID');
          navigate('/login', { replace: true });
          return;
        }

        const sessionId = sessionIdMatch[1];
        console.log('Processing OAuth callback with session_id');

        // Exchange session_id for our app's token via backend
        const response = await api.get('/auth/google/session', {
          params: { session_id: sessionId }
        });

        const { access_token, user } = response.data;

        if (!access_token || !user) {
          throw new Error('Invalid response from server');
        }

        // Store token and user data
        localStorage.setItem('token', access_token);
        loginWithToken(access_token, user);

        // Show success message
        toast.success(`Welcome${user.first_name ? `, ${user.first_name}` : ''}!`);

        // Clear the URL hash
        window.history.replaceState(null, '', window.location.pathname);

        // Redirect based on user role and status
        if (['admin', 'main_admin', 'company_admin'].includes(user.role)) {
          navigate('/admin', { replace: true, state: { user } });
        } else {
          navigate('/admin/dashboard', { replace: true, state: { user } });
        }
      } catch (error) {
        console.error('OAuth callback error:', error);
        toast.error('Authentication failed. Please try again.');
        navigate('/login', { replace: true });
      }
    };

    processAuth();
  }, [navigate, loginWithToken]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-gray-600">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
